import { render, staticRenderFns } from "./RRTC.vue?vue&type=template&id=50e3e2ae&"
import script from "./RRTC.vue?vue&type=script&lang=js&"
export * from "./RRTC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports